import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=22b555f5"
import script from "./chat.js?vue&type=script&lang=js&external"
export * from "./chat.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports